import React from "react";

const ArrowRight = ({ color = "black", height = 10, width = 11 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 11 10" fill="none" style={{ overflow: 'visible' }}>
    <path d="M0 4.12509H7.78474L4.73854 1.15503L5.92317 0L11.0002 4.95011L5.92317 9.90022L4.73854 8.74519L7.78474 5.77513H0V4.12509Z" fill={color} stroke="white" strokeWidth="3" strokeLinejoin="round" paintOrder="stroke" />
  </svg>
);

export default ArrowRight;
